import type { SavedCommodity } from "@freightsimple/generated-dashboard-openapi-client/models/SavedCommodity";

const descriptionCollator = new Intl.Collator(undefined, {
  sensitivity: "base",
});

function matchesFilter(sc: SavedCommodity, tokens: string[]): boolean {
  if (tokens.length === 0) {
    return true;
  }
  const haystack = [
    sc.description,
    sc.skuIdentifier ?? "",
    sc.nmfcItemNumber ?? "",
    sc.dangerousUnNumber ?? "",
  ]
    .join(" ")
    .toLowerCase();
  return tokens.every((token) => haystack.includes(token));
}

// Every whitespace-separated token must appear somewhere in the commodity's
// description, SKU, NMFC or UN number, so "pallet 1234" narrows on both.
export function filterSavedCommodities(
  savedCommodities: SavedCommodity[],
  filter: string | undefined,
): SavedCommodity[] {
  const tokens = (filter ?? "")
    .trim()
    .toLowerCase()
    .split(/\s+/)
    .filter((t) => t.length > 0);
  return savedCommodities
    .filter((sc) => matchesFilter(sc, tokens))
    .sort((a, b) => descriptionCollator.compare(a.description, b.description));
}
